import { render, staticRenderFns } from "./staff-table.vue?vue&type=template&id=5315efef&"
import script from "./staff-table.vue?vue&type=script&lang=js&"
export * from "./staff-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports